import React, {
    useState,
    useEffect,
} from 'react'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import NumberFormat from 'react-number-format';
import 'simplebar/dist/simplebar.min.css'
import Parser from 'html-react-parser';

// Atoms
import Button from './../../../Atoms/Button'
// import Dropdown from './../../../Atoms/Dropdown'
import SearchField from './../../../Atoms/SearchField'
import Title, { TitleTag, TitleStyle } from './../../../Atoms/Title';

// Mol
// import PlayPlanCardMol from './../../../Molecules/Cards/Plan/Play'
import General2PlanCardMol from './../../../Molecules/Cards/Plan/General2'
// import BreadcrumbMol from 'Components/Molecules/Breadcrumb'
import PaginationMol from './../../../Molecules/Pagination'

// Sass
import '../../../../Sass/includes/Components/modules/C23.sass'

import C25PeopleOrg from '../C25'

function C23PersonasOrg(props) {
    const {
        dataChannelsBk,
        dataCategoriasBk,
    } =props
    // let history = useHistory();
    const [dataCPlanes, setdataCPlanes] = useState([])
    const [dataCPlanesBk, setdataCPlanesBk] = useState([])
    const [dataFilterTypes, setDataFilterTypes] = useState([])
    const [inputSearch, setinputSearch] = useState('')
    const [optionFilter, setOptionFilter] = useState('')
    const [optiondHigherLower, setOptiondHigherLower] = useState('')
    const [offset, setOffset] = useState(0)
    const [pageCount, setPageCount] = useState(1)
    const [perPage, setPerPage] = useState(6)
    const [dataToItems, setDataToItems] = useState([])
    const [preFilterRemove, setPreFilterRemove] = useState(true)


    const [keysPlanCompare, setKeysPlanCompare] = useState([])

    async function getCPlanes() {
        console.log("get_cplanes_byserviciocategoria********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fi_categoria = localStorage.getItem('fi_categoria') ? localStorage.getItem('fi_categoria') : '';
        let fi_servicio = localStorage.getItem('fi_servicio') ? localStorage.getItem('fi_servicio') : '';
        let fc_tipo_plan = localStorage.getItem('fc_tipo_plan') ? localStorage.getItem('fc_tipo_plan') : '';
        let fi_familia = localStorage.getItem('id_familia') ? localStorage.getItem('id_familia') : '';
        const configCPlanes = {
            method: 'GET',
            url: `${url_servicio_web}get_cplanes_byserviciocategoria?fi_servicio=${fi_servicio}&fi_categoria=${fi_categoria}&fc_tipo_plan=${fc_tipo_plan}&fi_familia=${fi_familia}`,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCPlanes)
        console.log("response- getCPlanes------------------------->", response);
        let pageCountVal = response.data ? (Math.ceil(response.data.length / perPage)) : 1;
        setdataCPlanes(response.data)
        await setdataCPlanesBk(response.data)

        setPageCount(pageCountVal)
        setPerPage(6)
        let version_comparador = localStorage.getItem('version_comparador')
        if(version_comparador === "v2"){
            setPerPage(8)
        }else{
            setPerPage(6)
        }
    }


    // async function getFilterTypes() {
    //     // console.log("getFilterTypes********************************+")
    //     let url_servicio_web = localStorage.getItem('url_servicio_web')
    //     let fc_familia = localStorage.getItem('id_familia')
    //     const configRegiones = {
    //         method: 'GET',
    //         url: url_servicio_web + "get_FilterTypes?fc_familia=" + fc_familia,
    //     };
    //     let response = await axios(configRegiones)
    //     let FilterTypes = [] //, elements = {}
    //     console.log("response- getFilterTypes------------------------->", response);

    //     response.data.forEach(dfilt => {
    //         FilterTypes.push({ id: dfilt.fi_OPCION_FILTRO, fi_FILTRO: dfilt?.fi_FILTRO, Descripcion: dfilt.fc_DESCRIPCION, checked: false, lstTipoFiltro: dfilt.lstTipoFiltro, disabled: false })
    //     });
    //     // console.log("setDataFilterTypes", FilterTypes)
    //     setDataFilterTypes(FilterTypes)
    // }


    const resetHandleClick = (el) => {

        console.log("resetHandleClick: " + el);
        setKeysPlanCompare([])
        setDataToItems([])
    }

    function removeItemHandleClick(el) {
        let idPlanRemove = parseInt(el.target.id)
        if (idPlanRemove) {
            let newarray = keysPlanCompare.filter(element => element !== idPlanRemove);
            // setKeysPlanCompare(newarray)
            console.log("removeItemHandleClick: " + el.target, "id: " + el.target.id, "name: " + el.target.name, idPlanRemove, newarray);
            setKeysPlanCompare(newarray)
            let dataToItems = dataCPlanesBk.filter(f => newarray.includes(f.fi_PLAN));
            let arrayItemes = { items: dataToItems }
            console.log("dataToItems::::::::::::::::::::" + dataToItems, arrayItemes, keysPlanCompare.length);
            setDataToItems(arrayItemes)
        }
        // setDataToItems([])
    }

    function onChangeInputSearch(e) {
        console.log("onChangeInputSearch", e.target.value)
        let textValue = e.target.value
        if (textValue.length) {
            setinputSearch(textValue)

        } else {
            let list = dataCPlanesBk
            list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
            setdataCPlanes(list)
            let pageCountVal = list.length ? (Math.ceil(list.length / perPage)) : 1;
            setOffset(0)
            setPageCount(pageCountVal)
        }
    }


    function getFilterPlansMulti(price = null, check = null, comuna = null, option = null, input = null, OrdHigherLower = null) {
        console.log("function getFilterPlansMulti*********** Init::::", dataCPlanesBk, "price: ", price, "check: " + check, "comuna: " + comuna, "option: " + option, "input: " + input)
        // if (inputSearch.length) {
        let data = dataCPlanesBk.length ? dataCPlanesBk : [];
        let ContaFilter = []

        let newDataFilter = data.filter((data, index) => {
            let flagInput = -1, flagComuna = -1, flagOption = -1, flagCheck = -1;

            if (input.length) {
                console.log("input if getFilterPlansMulti***********", "input: " + input)
                ContaFilter[0] = true
                for (let [key, value] of Object.entries(data)) {

                    if (key === "caracteristicas" && value.length) {
                        for (let [keyC, valueC] of Object.entries(value)) {
                            // let valueCS = String(value)

                            if (valueC.fc_TITULO.toLowerCase().search(inputSearch.toLowerCase()) > -1 || valueC.fc_VALOR.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                                console.log("------------------caracteristicas index:" + index, keyC, valueC.fc_TITULO.toLowerCase(), valueC.fc_VALOR.toLowerCase(), inputSearch.toLowerCase());
                                flagInput = index
                            }
                        }
                    } else {
                        let valueS = String(value)
                        // console.log("------------------ index:"+index, valueS.toLowerCase(), inputSearch.toLowerCase());
                        if (valueS.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                            console.log("------------------ index:" + index, key, valueS.toLowerCase());
                            flagInput = index
                        }
                    }
                }
            }
            if (comuna) {
                let dcomuna = data.fc_TIPO_DISPONIBILIDAD === comuna;
                ContaFilter[1] = true
                if (dcomuna) {
                    flagComuna = 1
                }
                console.log("comuna if getFilterPlansMulti***********", "comuna: " + comuna, flagComuna)
            }
            if (option) {
                let doption = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(option)))
                ContaFilter[2] = true
                if (doption !== undefined) {
                    flagOption = doption.fi_OPCION_FILTRO
                }
                console.log("option if getFilterPlansMulti***********", "option: " + parseInt(option), flagOption)
            }
            if (check) {

                // let dcheck = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(check)))
                // ContaFilter[4] = true
                // if (dcheck !== undefined) {
                //     flagCheck = dcheck.fi_OPCION_FILTRO
                // }
                // let getByChecked = dataFilterTypes.map((filt, index) => {
                //     if (filt.checked) {
                //         console.log("check if getFilterPlansMulti*********** check:", filt)
                //         return data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === filt.id))
                //     } else {
                //         return null;
                //     }
                // })

                let arraykeyCheck = []
                let keysConta = 3
                let CheckedsBox = dataFilterTypes.map((filt, index) => {
                    if (filt.checked) {
                        keysConta += index
                        arraykeyCheck.push(filt.id)
                        ContaFilter[keysConta] = true
                    }
                    return filt
                })

                let isExist = false
                let result = data.lstFiltrosxPlan.map(option => {
                    let isSameId = arraykeyCheck.includes(option.fi_OPCION_FILTRO)
                    if (isSameId) isExist = true
                    return isExist
                })
                if (isExist) {
                    flagCheck = 1
                }

                console.log("check if getFilterPlansMulti*********** CheckedsBox: isExist", isExist, CheckedsBox, result)
            }

            if (flagInput > -1 || flagComuna > -1 || flagOption !== -1 || flagCheck > -1) {
                console.log("FLAGS-------------", flagInput, flagComuna, flagOption, flagCheck, data)
                return data
            } else {
                console.log("FLAGS ELSE-------------", flagInput, flagComuna, flagOption, flagCheck)
                return null
            }
        });
        let dataNew = newDataFilter.length ? newDataFilter : data
        console.log("FLAGS newDataFilter-------------", dataNew)
        let newDataFilterPrices = dataNew.filter((data, index) => {
            let flagPrices = 1
            if (price) {
                let dprice = ((data.fi_PRECIO_PLAN >= price.min) === true && (data.fi_PRECIO_PLAN <= price.max) === true);
                // ContaFilter[3] = true
                if (dprice) {
                    flagPrices = 1
                }
                console.log("function getFilterPlansMulti*********** price: ", price, dprice)
            }
            if (flagPrices > -1) {
                return data
            } else {
                return null
            }
        })
        let counter = 0
        ContaFilter.map((item, index) => (
            counter++
        ))


        let list = newDataFilterPrices
        let list2 = newDataFilterPrices
        list.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
        if (OrdHigherLower !== null) {
            console.log("OrdHigherLower !null ", OrdHigherLower)
            if (OrdHigherLower === "1") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower >", OrdHigherLower)
            }
            if (OrdHigherLower === "2") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN < b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower <", OrdHigherLower)
            }
            console.log("to OrdHigherLower----------:", list2)
            list = list2
        }

        let pageCountVal = newDataFilterPrices.length ? (Math.ceil(newDataFilterPrices.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        // getMinMaxPrice()
        setOffset(0)
        console.log("to search---------- getFilterPlans:", pageCount, pageCountVal, perPage, newDataFilterPrices, newDataFilterPrices.length)
        // }
    }

    function onHandleClickSearch(e) {
        getFilterPlansMulti(null, dataFilterTypes, null, optionFilter, inputSearch)
    }

    function handlePageClick(d) {
        console.log("handlePageClick::::::::::::::::::::::::", d)
        setOffset(d.selected)
    }

    useEffect(() => {
        // getFilterTypes();
        setDataFilterTypes([])
        getCPlanes();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        let preFilter = localStorage.getItem('preFilter') ? localStorage.getItem('preFilter').split(",") : '';
        console.log("preFilter::::::::::::::::::::::::", preFilter)
        if (preFilter.length) {
            let FilterId = parseInt(preFilter[1].split(":")[1])
            let filterOption = preFilter[1].split(":")[0]
            console.log("preFilter length::::::::::::::::::::::::", preFilter, FilterId, filterOption)
            if (filterOption === "FilterId") {
                let newArrayChecks = dataFilterTypes.map((filt, index) => {
                    if (filt.id === FilterId) {
                        filt.checked = true
                    }
                    return filt;
                })
                console.log("FilterId === 1::::::::::::::::::::::::", preFilter, FilterId, filterOption, newArrayChecks)
                setOptionFilter('')
                if (dataCPlanesBk?.length) {
                    console.log("dataCPlanesBk?.length............................... type 1", preFilterRemove, filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                    if (preFilterRemove) {
                        console.log("preFilter............................... type 1", filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                        getFilterPlansMulti(null, newArrayChecks, null, '', inputSearch)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                        console.log("preFilter............................... removeItem 1")
                    }
                }
            } else if (filterOption === "filterOption") {
                console.log("FilterId === 2::::::::::::::::::::::::", preFilter, FilterId, filterOption)
                setOptionFilter(filterOption)

                if (dataCPlanesBk?.length) {
                    if (preFilterRemove) {
                        console.log("preFilter............................... type 2", filterOption, dataCPlanesBk, dataCPlanes)
                        getFilterPlansMulti(null, dataFilterTypes, null, filterOption, inputSearch)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                    }
                }
            }
        }
        // eslint-disable-next-line
    }, [dataCPlanesBk, pageCount])

    function calculateInitElementShow() {
        const result = offset * perPage
        return result
    }

    function calculateFnElementShow() {
        return calculateInitElementShow() + perPage
    }

    function getCalculatePageCount() {

        let pageCountVal = dataCPlanes?.length ? (Math.ceil(dataCPlanes.length / perPage)) : 1;
        return pageCountVal
    }

    function onChangeOptions(e) {
        let OrdHigherLower = e.target.value
        setOptiondHigherLower(OrdHigherLower)
        getFilterPlansMulti(null, dataFilterTypes, null, optionFilter, inputSearch, OrdHigherLower)
        console.log("onChangeOptions:", e.target.value, e)
    }


    const PlayPLanData = dataCPlanes.length ? dataCPlanes.slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => (
        <div key={uuid()} className="c23Item" data-idplan={item.fi_PLAN}>
            <General2PlanCardMol
                key={uuid()}
                title={item.fc_TEXTO_CAJA.trimEnd()}
                titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
                name={item.fc_NOMBRE.trimEnd()}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={item.fi_PRECIO_PLAN > 0 ? <NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item.fi_PRECIO_PLAN) ? item.fi_PRECIO_PLAN : item.fi_PRECIO_PLAN.toFixed(2)} />: null}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO } />}
                Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                fc_TITULO_PROMO={item.fc_TITULO_PROMO}
                Caracteristicas={item.caracteristicas}
                caracteristicasPromocion={item.caracteristicasPromocion}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
                fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
                fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
                fc_TITULO_SECCION={item.fc_TITULO_SECCION}
                fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
                fc_TARGET_BOTON={item.fc_TARGET_BOTON}
                fc_URL_BOTON={item.fc_URL_BOTON}
                fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
                fc_PLAN_ICONO={item.fc_PLAN_ICONO}
                fc_DETALLE_PLAN={item?.fc_DETALLE_PLAN ? item.fc_DETALLE_PLAN : ""}
                fi_SERVICIO={item.fi_SERVICIO}
                fc_FAMILIA={item.fc_FAMILIA}
                dataChannelsBk={dataChannelsBk}
                dataCategoriasBk={dataCategoriasBk}
            />
            {/* <PlayPlanCardMol
                key={uuid()}
                title={item.fc_TEXTO_CAJA}
                titlestyle={item.fc_COLOR_CAJA.toLowerCase()}
                name={item.fc_NOMBRE}
                changeCompare={handleChangeCompare}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fi_PRECIO_PLAN} />}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fc_PRECIO_TACHADO} />}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                Caracteristicas={item.caracteristicas}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
            /> */}
        </div>
    )) : null

    // const optionsFilterOptions = dataFilterOptions.length ? dataFilterOptions.map((item, index) => (
    //     <option key={uuid()} value={item.value}>{item.label}</option>
    // )) : null

    console.log('dataFilterTypes----', dataFilterTypes, pageCount, "perPage:",perPage);

    return (

        dataToItems?.items
            ?
            <C25PeopleOrg
                dataCompare={dataToItems}
                resetHandleClick={resetHandleClick}
                removeItemHandleClick={removeItemHandleClick}
            />
            :
            <section className='c23Wrap'>
                <div className="c23Breadcrumb">
                    {/* <BreadcrumbMol 
                        backToText='Volver a Servicios Hogar'
                    /> */}
                </div>
                <div className="container">
                    <div className="c23">
                        <div className="c23Cont extend">

                            <Title
                                tag={TitleTag.H2}
                                style={TitleStyle.H2}
                                className='c23HeaderTit'
                            >
                                {
                                    localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : Parser("&nbsp;")
                                }
                            </Title>

                            <div className="c23Bar">
                                <div className="c23BarDrop">
                                    <span className="select">
                                        <select value={optiondHigherLower} onChange={(e) => { onChangeOptions(e) }}>
                                            <option value='' disabled>Ordenar por:</option>
                                            <option value='1'>Precio: Menor a mayor</option>
                                            <option value='2'>Precio: Mayor a menor</option>
                                        </select>
                                    </span>

                                </div>
                                <div className="c23BarSearch">
                                    <SearchField
                                        onChange={e => onChangeInputSearch(e)}
                                        value={inputSearch}
                                    />

                                </div>
                                <div className="c23BarAct">
                                    <Button
                                        onClick={e => onHandleClickSearch(e)}
                                    >
                                        Buscar
                                    </Button>
                                </div>
                            </div>

                            <div className="c23Header">

                                {/* <div className='c23HeaderFilter' onClick={() => { setShowFilter(!showFilter) }}>

                                    <p>Filtros <i className='ico-sliders'></i></p>

                                </div> */}
                                {/*<div className="c23HeaderComp">
                                    <div className="c23HeaderCompRad">
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[0]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[0] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[1]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[1] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[2]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[2] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[3]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[3] ? true : false}
                                        />
                                    </div>
                                    <div className="c23HeaderCompBtn">

                                        <Button
                                            category={ButtonCategory.TRANS_GRIS}
                                            onClick={keysPlanCompare.length >= 2 ? e => routeChange(e) : null}
                                        >
                                            Comparar servicios
                                        </Button>
                                    </div>

                                </div>*/}
                            </div>

                            <div className="c23Items">
                                {/* <div className="c23Item">
                                <PlayPlanCardMol
                                    changeCompare={handleChangeCompare}
                                />
                            </div> */}
                                {
                                    PlayPLanData
                                }

                            </div>
                            <div className="c23Pag">
                                {
                                    dataCPlanes.length
                                        ?
                                        <PaginationMol
                                            pageCount={getCalculatePageCount()}
                                            onPageChange={handlePageClick}
                                            initialPage={0}
                                            forcePage={offset}
                                        // previousLabel={'Ant.'}
                                        // nextLabel={'Sig.'}
                                        />
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default C23PersonasOrg